import React, { useState, useRef } from 'react'
import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    IconButton,
    Button,
    Stack,
    Text,
    Divider,
    Badge,
    Tooltip,
} from '@chakra-ui/react';
import { CgEyeAlt } from 'react-icons/cg';
import Moment from 'moment';

export const ModalDetallesPersona = ({ persona }) => {

    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const btnRef = useRef();

    const handleOpenDrawer = () => {
        setIsOpenDrawer(true);
    }

    const handleCloseDrawer = () => {
        setIsOpenDrawer(false);
    }

    return (
        <>
            <Tooltip hasArrow label='Ver Detalles' placement='auto'>
                <IconButton
                    aria-label="Ver"
                    icon={<CgEyeAlt />}
                    fontSize="xl"
                    _dark={{ color: "white", _hover: { bg: "blue.800" } }}
                    colorScheme="blue"
                    variant={'ghost'}
                    onClick={handleOpenDrawer}
                    ml={2}
                />
            </Tooltip>
            <Drawer
                isOpen={isOpenDrawer}
                placement='bottom'
                onClose={handleCloseDrawer}
                finalFocusRef={btnRef}
                size="xl"
            >
                <DrawerOverlay />
                <DrawerContent _dark={{ bg: "primary.1000" }}>
                    <DrawerHeader fontWeight="bold" bg="blue.600" color="gray.200" textAlign="center">INFORMACIÓN BASICA DEL REGISTRO SELECCIONADO</DrawerHeader>
                    <DrawerBody>
                        <Stack direction="column" mt={6} px={[0, 10, 40, 60]}>

                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">ESTADO:</Text>
                                    <Badge
                                        colorScheme={persona?.estado === true ? 'green' : 'red'}
                                        variant="solid"
                                        px={6}
                                        py={1.5}
                                        rounded="full"
                                    >
                            
                                    </Badge>
                                </Stack>
                            <Divider />

                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">NOMBRE:</Text>
                                    <Text>{persona?.nombres}</Text>
                                </Stack>
                            <Divider />

                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">CEDULA:</Text>
                                    <Text>{persona?.cedula}</Text>
                                </Stack>
                            <Divider />

                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">CIUDAD:</Text>
                                    <Text>{persona?.ciudad}</Text>
                                </Stack>
                            <Divider />

                            <Divider />
                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                <Text fontWeight="bold">EMAIL:</Text>
                                <Text>{persona?.email}</Text>
                            </Stack>
                            <Divider />

                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">DIRECCION:</Text>
                                    <Text>{persona?.direccion}</Text>
                                </Stack>
                            <Divider />
                

                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">CELULAR:</Text>
                                    <Text>{persona?.celular}</Text>
                                </Stack>
                            <Divider />

                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">FECHA NACIMIENTO:</Text>
                                    <Text>{Moment(persona?.fechaNacimiento).format('DD/MM/YYYY')}</Text>
                                </Stack>
                            <Divider />
                            <Divider />
                                <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                    <Text fontWeight="bold">FECHA DE INGRESO:</Text>
                                    <Text>{Moment(persona?.fechaIngreso).format('DD/MM/YYYY')}</Text>
                                </Stack>
                            <Divider />
                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                <Text fontWeight="bold">FECHA CREADA:</Text>
                                <Text>{Moment(persona?.createdAt).format('DD/MM/YYYY - hh:mm:ss A')}</Text>
                            </Stack>
                            <Divider />

                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                <Text fontWeight="bold">FECHA ULTIMA MODIFICACION:</Text>
                                <Text>{Moment(persona?.updatedAt).format('DD/MM/YYYY - hh:mm:ss A')}</Text>
                            </Stack>
                            <Divider />
                            
                        </Stack>
                    </DrawerBody>

                    <DrawerFooter w="full" justifyContent="center" textAlign="center" alignItems="center" display="flex">
                        <Button 
                            colorScheme="blue" 
                            _dark={{ bg: "blue.600", color: "white", _hover: { bg: "blue.700" } }} 
                            size="lg" 
                            onClick={handleCloseDrawer}
                            borderRadius="xl"
                        >
                            OK
                        </Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </>
    )
}
